import React, { useCallback, useContext, useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import dayjs from 'dayjs'
import { Card, Grid } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

import PageUrls from '../../../../constants/page-urls'
import useAxios from '../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../types/pagination'
import { IUserLists } from '../../../../types/user'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { useDispatch } from 'react-redux'
import { openModal } from '../../../../../store/reducers/modal/modal.slice'
import { AbilityContext } from '../../../../components/Ability'
import CustomerBlackListFilter, {
  IFilterMapped,
} from './components/CustomerBlackListFilter'
import CustomerBlackListTable from './components/CustomerBlackListTable'
import { CustomerBlackListFormModal } from './components/CustomerBlackListFormModal'
import { ICustomerBlackList } from '../../../../types/customerBlackList'

const Menus = [
  {
    breadcrumbName: 'รายงานผู้ใช้งาน',
    title: 'รายงานผู้ใช้งาน',
    path: PageUrls.Users,
  },
  {
    breadcrumbName: 'รายงานร้านค้า',
    title: 'รายงานร้านค้า',
    path: PageUrls.Merchant,
  },
]

const CreateCustomerBlackListPage = () => {
  const ability = useContext(AbilityContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)
  const [isModalCreateCustomerBlackList, setIsModalCreateCustomerBlackList] =
    useState<boolean>(false)

  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    search: queryStr.search?.length
      ? String(queryStr.search).toLowerCase()
      : undefined,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    search: queryStr.search?.length
      ? String(queryStr.search).toLowerCase()
      : undefined,
  })

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Customer.BlackList}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const customerBlackList = useAxios<
    PaginationResponseInterface<ICustomerBlackList>
  >({
    method: 'GET',
    url: '/blacklists',
    params: searchFilter,
  })

  const handlePageChange = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Customer.BlackList}?${newQuery}`, {
      replace: true,
    })
  }

  const onUpdateCustomerBlackListSuccess = useCallback(async () => {
    try {
      await customerBlackList.mutate()
    } catch (error) {}
  }, [filter])

  return (
    <ContentWrapper>
      <Helmet title="รายงานลูกค้า Black List" />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายงานลูกค้า Black List"
            routes={Menus}
            descriptions="รายการข้อมูลลูกค้า Black List ในระบบ"
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="large"
            startIcon={<AddIcon />}
            onClick={() =>
              dispatch(
                openModal({
                  title: 'สร้างลูกค้า Black List',
                  content: (
                    <CustomerBlackListFormModal
                      onUpdateCustomerBlackListSuccess={
                        onUpdateCustomerBlackListSuccess
                      }
                    />
                  ),
                }),
              )
            }
          >
            สร้างลูกค้า Black List
          </Button>
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <CustomerBlackListFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        <CustomerBlackListTable
          isLoading={customerBlackList.isLoading}
          data={customerBlackList.data?.records ?? []}
          onUpdateCustomerBlackListSuccess={onUpdateCustomerBlackListSuccess}
          filter={{ ...filter }}
          onFilterChange={onFilterChange}
          handlePageChange={handlePageChange}
          total={customerBlackList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default CreateCustomerBlackListPage
